(() => {
  if (window.__KervelanSearchCatalogStabilityLoaded) return;
  window.__KervelanSearchCatalogStabilityLoaded = true;

  const ROOT_SELECTOR = '.kvs-collection-results';
  const GRID_SELECTOR = `${ROOT_SELECTOR} .product-grid`;
  const BOOT_ATTR = 'data-kv-search-catalog-boot';
  const MAX_WAIT_MS = 1800;

  const setReady = () => {
    document.documentElement.setAttribute(BOOT_ATTR, 'ready');
  };

  const waitForImage = async (image) => {
    if (!(image instanceof HTMLImageElement)) return;

    const loadPromise = image.complete
      ? Promise.resolve()
      : new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });

    await loadPromise;

    if (typeof image.decode === 'function') {
      try {
        await image.decode();
      } catch (_) {
        // A failed decode should never keep the catalog hidden.
      }
    }
  };

  const getFirstRowImages = (grid) => {
    const items = [...grid.children].filter((item) => item instanceof HTMLElement);
    if (!items.length) return [];

    const firstTop = Math.round(items[0].getBoundingClientRect().top);
    const firstRow = items.filter((item) => Math.abs(Math.round(item.getBoundingClientRect().top) - firstTop) <= 5);

    return firstRow
      .map((item) => item.querySelector('.kv-product-card__image--primary'))
      .filter((image) => image instanceof HTMLImageElement);
  };

  const stabilize = async () => {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!(grid instanceof HTMLElement)) {
      setReady();
      return;
    }

    const images = getFirstRowImages(grid);
    if (!images.length) {
      setReady();
      return;
    }

    const timeout = new Promise((resolve) => window.setTimeout(resolve, MAX_WAIT_MS));
    await Promise.race([Promise.all(images.map(waitForImage)), timeout]);
    setReady();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stabilize, { once: true });
  } else {
    stabilize();
  }

  window.addEventListener('pageshow', () => {
    if (document.documentElement.getAttribute(BOOT_ATTR) !== 'ready') stabilize();
  });
})();
